import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './DynamicArea.css';
import Editor from '../editor/Editor';

class DynamicArea extends Component {
  setDebounce() {
    this.setTimeout = clearTimeout(this.setTimeout);
    this.setTimeout = setTimeout(this.stopRendering, 400);
  }

  canDropImage = () => true


  render() {
    const editorProps = {
      height: 'auto',
      width: '100%',
    };

    const {
      isChange,
      placeholders,
      pages,
      lang,
      backgroundPlaceholders,
    } = this.props;
    return (
      <div className="DynamicArea">
        <Editor
          {...editorProps}
          canDropImage={this.canDropImage}
          dropImage={this.dropImage}
          isChange={isChange}
          placeholders={placeholders}
          backgroundPlaceholders={backgroundPlaceholders}
          pages={pages}
          lang={lang}
        />
      </div>
    );
  }
}

DynamicArea.defaultProps = {
  placeholders: {},
  dispatch: () => {},
  lang: {},
  layouts: {},
  isChange: false,
  pages: {},
  coverType: '',
};

DynamicArea.propTypes = {
  placeholders: PropTypes.object,
  dispatch: PropTypes.func,
  lang: PropTypes.object,
  layouts: PropTypes.object,
  isChange: PropTypes.bool,
  pages: PropTypes.object,
  coverType: PropTypes.string,
};

export default connect(state => ({
  placeholders: state.entities.placeholders,
  backgroundPlaceholders: state.entities.backgroundPlaceholders,
  pages: state.entities.pages,
  isChange: state.editorUI.imageChange.isChange,
  layouts: state.entities.layouts.byId,
  backgroundType: state.editorUI.bookProperties.backgroundType,
  coverType: state.bookProperties.cover.type,
}))(DynamicArea);



// WEBPACK FOOTER //
// ./src/components/dynamic-area/DynamicArea.jsx